import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {environment} from '../../../environments/environment';
import {INewPayment} from '../../shared/model/interface/new-payment.model.interface';
import {IPayment} from '../../shared/model/interface/payment.model.interface';
import {WebsocketService} from './websocket.service';
import {IObjectPage} from "../../shared/model/interface/object-page.model.interface";
import {HttpParamsFactory} from "../../shared/factory/http-params.factory";
import {PageEvent} from "@angular/material/paginator";
import {IBase64File} from "../../shared/model/interface/base64-file.model.interface";
import {map} from "rxjs/operators";
import {Base64FileHelper} from "../../shared/helper/base64-file.helper";

@Injectable({
  providedIn: 'root'
})
export class PaymentService {
  constructor(private http: HttpClient,
              private websocketService: WebsocketService) {
  }

  private URL = environment.backendUrl;

  connectToWebsocket(legalCaseCoreId: number) {
    return  this.websocketService.subscribeToPayments(legalCaseCoreId);
  }

  getAllByLegalCaseCoreId(legalCaseId: number) {
    return this.http.get<IObjectPage<IPayment>>(this.URL + `/aggregator/payments?legalCaseCoreId=${legalCaseId}&size=50&page=0`);
  }

  getPageByLegalCaseCoreId(search: any, event: PageEvent) {
    const params = HttpParamsFactory.notNullsFromObject(search, event)
    return this.http.get<IObjectPage<IPayment>>(this.URL + `/aggregator/payments`,{ params });
  }

  createPayment(payload: INewPayment) {
    return this.http.post<IPayment>(this.URL + '/payments', payload)
  }

  deletePayment(paymentId: string) {
    return this.http.delete(this.URL + `/payments/${paymentId}`);
  }

  loadPayments(paymentsFile: File, instructingId: number) {
    const formData: FormData = new FormData();
    formData.append('file', paymentsFile);

    return this.http.post(this.URL + `/payments/load/${instructingId}`, formData);
  }

  attachActionCodeToPayment(paymentId: number, actionCodeId: number) {
    return this.http.post(this.URL + `/payments/${paymentId}/action-code/${actionCodeId}`, null);
  }

  detachActionCodeToPayment(paymentId: number) {
    return this.http.delete(this.URL + `/payments/${paymentId}/action-code`, null);
  }


  export(legalCaseCoreId: number) {
    return this.http.get<IBase64File>(this.URL + `/export/payments/${legalCaseCoreId}`).pipe(
      map(file => Base64FileHelper.decodeFilename(file))
    );
  }
}
